import isFunction from "lodash/isFunction";
import { Tabs } from "@circle-react-uikit/Tabs";
import type { TabProps } from "@circle-react-uikit/Tabs/Tab";

export interface TabNavigationViewProps extends Record<string, any> {
  currentTab?: string;
  onTabClick?: (tab: string) => void;
  tabs: Array<TabProps>;
}

/** @deprecated Please use the new Tab at "@circle-react-uikit/TabV2" */
export const TabNavigationView = ({
  tabs,
  currentTab,
  onTabClick,
  ...rest
}: TabNavigationViewProps) => (
  <Tabs
    variant="underline"
    className="sticky grow-0"
    wrapperClassName="px-8 overflow-x-auto"
    controlled
    activeTab={currentTab}
    onClick={(tab: string) => isFunction(onTabClick) && onTabClick(tab)}
    options={tabs}
    {...rest}
  />
);
